
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.6 8.4C37.2 4 31.3 1.5 25 1.5 18.7 1.5 12.8 4 8.4 8.4 4 12.8 1.5 18.7 1.5 25c0 6.3 2.4 12.2 6.9 16.6 4.4 4.4 10.3 6.9 16.6 6.9 6.3 0 12.2-2.4 16.6-6.9s6.9-10.3 6.9-16.6c0-6.3-2.5-12.2-6.9-16.6zm-15.3 7.9c2.4-.1 4.8-.3 7.1-.8.6 2.6 1 5.3 1 8.3h-8.1v-7.5zm0-2.5V4.3c1.9.6 3.7 2.6 5.1 5.6.5 1 .9 2.1 1.3 3.2-2.1.4-4.2.6-6.4.7zm-2.5-9.5v9.5c-2.2-.1-4.4-.3-6.4-.7.4-1.2.8-2.2 1.3-3.2 1.4-3.1 3.2-5 5.1-5.6zm0 12v7.5h-8.1c.1-2.9.4-5.7 1-8.3 2.2.5 4.6.7 7.1.8zm-10.6 7.5H4.1c.2-4.2 1.8-8.1 4.1-11.3 1.8 1 3.8 1.8 6 2.4-.6 2.7-1 5.7-1 8.9zm0 2.5c.1 3.2.5 6.2 1.1 8.9-2.2.6-4.3 1.4-6 2.4-2.4-3.2-3.9-7.1-4.1-11.3h9zm2.5 0h8.1v7.5c-2.4.1-4.8.3-7.1.8-.6-2.6-1-5.4-1-8.3zm8.1 9.9v9.5c-1.9-.6-3.7-2.6-5.1-5.6-.5-1-.9-2.1-1.3-3.2 2-.4 4.1-.6 6.4-.7zm2.5 9.5v-9.5c2.2.1 4.4.3 6.4.7-.4 1.2-.8 2.2-1.3 3.2-1.5 3.1-3.3 5-5.1 5.6zm0-12v-7.5h8.1c-.1 2.9-.4 5.7-1 8.3-2.3-.4-4.7-.7-7.1-.8zm10.5-7.4h9.1c-.2 4.2-1.8 8.1-4.1 11.3-1.8-1-3.8-1.8-6-2.4.6-2.8 1-5.8 1-8.9zm0-2.5c-.1-3.2-.5-6.2-1.1-8.9 2.2-.6 4.3-1.4 6-2.4 2.4 3.2 3.9 7.1 4.1 11.3h-9zm3.3-13.3c-1.5.8-3.2 1.5-5 2-1-3-2.3-5.6-3.8-7.5 3.4 1.1 6.4 3 8.8 5.5zM18.7 5c-1.5 1.9-2.8 4.4-3.8 7.5-1.8-.5-3.5-1.2-5-2C12.3 8 15.3 6.1 18.7 5zM9.9 39.5c1.5-.8 3.2-1.5 5-2 1 3 2.3 5.6 3.8 7.5-3.4-1.1-6.4-3-8.8-5.5zM31.3 45c1.5-1.9 2.8-4.4 3.8-7.5 1.8.5 3.5 1.2 5 2-2.4 2.5-5.4 4.4-8.8 5.5z"}})])
          )
        }
      }
    